import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps} from './DictionarySelector'

export const ActiveStatusSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="activeStatus"
                        loader={() => Promise.resolve([
                            {id: 'true', name: 'Active'},
                            {id: 'false', name: 'Inactive'}
                        ])}
    />